<div  class="spinner-overlay" *ngIf="spinnerService.isLoading$ | async">
    <div class="spinner"></div>
  </div>